import { ulid } from 'ulid';
import { ULID_REGEX } from '../validation';

const RETRY_TIMES = 5;

export const generateId = () => {
  for (let i = 0; i < RETRY_TIMES; i++) {
    const id = ulid();

    if (ULID_REGEX.test(id)) {
      return id;
    } else {
      // eslint-disable-next-line no-console
      console.log(`Invalid ULID ${id} ${Date.now()}. Attempts: ${i + 1}`);
    }
  }

  throw new Error('Could not generate a valid ULID');
};
